import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';

const PDFReceiptInfoDialog = ({ open, onClose, row }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle><b>TAARIFA ZA MALIPO</b></DialogTitle>
      <DialogContent>
        <div>
      {row ? (
        <iframe
          src={`data:application/pdf;base64,${row}`}
          width="100%"
          height="600px"
          title="Immigration Bill PDF"
        />
      ) : (
        <p>Generating PDF...</p>
      )}
    </div>
      </DialogContent>
      <DialogActions>
      <Button
          className="btn"
          onClick={onClose}
          style={{
            backgroundColor: "#17a2b8",
            color: "white",
          }}
        >
          <b>Funga</b>
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PDFReceiptInfoDialog;
